var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"diy-modal__content-close"},[_c('AppButtonIcon',{attrs:{"effect":"rotate"},on:{"click":_vm.submitCloseAciton}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }